'use strict';

import Vue from 'vue'
import VueRouter from 'vue-router';
import Home from './components/Home';
import Error from './components/Error';

Vue.use(VueRouter);

export default new VueRouter({
    mode: 'history',
    routes: [
        { path: '/:locale/:checkoutId', component: Home, name: 'home', props: true },
        { path: '/:locale', component: Error, name: 'error', props: true },
    ]
});
